var PluginName;
(function (PluginName) {
    PluginName["DragAndDrop"] = "dragAndDrop";
    PluginName["EventModal"] = "eventModal";
    PluginName["ScrollController"] = "scrollController";
    PluginName["EventRecurrence"] = "eventRecurrence";
    PluginName["Resize"] = "resize";
    PluginName["CalendarControls"] = "calendarControls";
    PluginName["Sidebar"] = "sidebar";
    PluginName["Header"] = "header";
})(PluginName || (PluginName = {}));

// regex for strings between 00:00 and 23:59
const dateStringRegex = /^(\d{4})-(\d{2})-(\d{2})$/;

class CalendarControlsPluginImpl {
    constructor() {
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: PluginName.CalendarControls
        });
        Object.defineProperty(this, "$app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    beforeInit($app) {
        this.$app = $app;
    }
    /**
     * TODO v2: remove this method
     * */
    init($app) {
        this.$app = $app;
    }
    setDate(date) {
        if (!dateStringRegex.test(date))
            throw new Error('Invalid date. Expected format YYYY-MM-DD');
        this.$app.datePickerState.selectedDate.value = date;
    }
    setView(view) {
        const viewToSet = this.$app.config.views.find((v) => v.name === view);
        if (!viewToSet)
            throw new Error(`Invalid view name. Expected one of ${this.$app.config.views.map((v) => v.name).join(', ')}`);
        this.$app.calendarState.setView(view, this.$app.datePickerState.selectedDate.value);
    }
    getDate() {
        return this.$app.datePickerState.selectedDate.value;
    }
    getView() {
        return this.$app.calendarState.view.value;
    }
    getRange() {
        return this.$app.calendarState.range.value;
    }
}
const createCalendarControlsPlugin = () => {
    return new CalendarControlsPluginImpl();
};

export { createCalendarControlsPlugin };
